// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3ARFG","box":"WorkspacesBox_box__aecYo","node":"WorkspacesBox_node__Rc_NA"};